/**
 * WEB-1988 — как HTTP-клиент говорит человеку, не зная про интерфейс.
 *
 * `api/client.ts` показывал два сообщения напрямую через `message` из Ant
 * Design («сессия истекла», «подтвердите почту»). Пока вход сборки был один,
 * это ничего не стоило; со вторым входом (страница покупателя воронки) любой
 * импорт клиента тянул в бандл покупателя всю библиотеку —
 * см. `src/build-guards/publicEntryGuard.ts`.
 *
 * Теперь клиент зовёт эти две функции, а КТО показывает — решает вход:
 * кабинет подключает antd-показчик (`installAntdApiNotifier`, вызов в
 * `main.tsx`), публичный вход не подключает никого и молчит — там нет ни
 * сессии кабинета, ни его тостов.
 */
export interface ApiNotifier {
  warning(text: string): void;
  error(text: string): void;
}

let notifier: ApiNotifier | null = null;

/** Подключить/снять показчик. Снятие (`null`) возвращает молчание. */
export function setApiNotifier(next: ApiNotifier | null): void {
  notifier = next;
}

export function notifyApiWarning(text: string): void {
  notifier?.warning(text);
}

export function notifyApiError(text: string): void {
  notifier?.error(text);
}
